// sort Array in asscending order
const compare = ( a, b ) => {
    if ( a.make < b.make ){
        return -1;
    }
    if ( a.make > b.make ){
        return 1;
    }
    return 0;
}

const splitAlphabeticalListByRange = (alphabetList, rangeChunks) => {
    // Create an object to hold the chunks
    const result = {};

    // Iterate through the rangeChunks
    for (const range of rangeChunks) {
        result[range] = alphabetList.filter(item => {
        if(item.make != null){
        // Extract the first letter of the name property and convert to uppercase
        const firstLetter = item.make.charAt(0).toUpperCase();
        return firstLetter >= range[0] && firstLetter <= range[2];
        }
        });
    }

    return result;
}

function handleError(type){
    let text;
    if(type == "air_filter"){
        text = `<h4 style="text-align: center;margin:20px 0px">
        Please <a href="/collections/vehicle-type-air-filter">Click Here</a> to start`;
    }
    else if(type == "cabin_air_filter"){
      text = `<h4 style="text-align: center;margin:20px 0px">
      Please <a href="/collections/vehicle-type-cabin-air-filter">Click Here</a> to start`;
      }
      else if(type == "transmission_filter"){
        text = `<h4 style="text-align: center;margin:20px 0px">
        Please <a href="/collections/vehicle-type-transmission-filter">Click Here</a> to start`;
    }
    else if(type == "fuel_filter"){
      text = `<h4 style="text-align: center;margin:20px 0px">
      Please <a href="/collections/vehicle-type-fuel-filter">Click Here</a> to start`;
    }
    else if(type == "oil_filter"){
      text = `<h4 style="text-align: center;margin:20px 0px">
      Please <a href="/collections/vehicle-type-air-filter">Click Here</a> to start`;
    }
    return text;
}

function findCommonData(arr1, arr2) {
    const commonData = [];
  
    for (const item1 of arr1) {
      for (const item2 of arr2) {
        if (item1.name === item2.ModelName) {
          commonData.push({ name: item1.name, handle: item1.handle });
          break;
        }
      }
    }
  
    return commonData;
}

function getCustomQueryParams(url) {
    // Create a URL object
    const urlObj = new URL(url);
    
    // Get the query string parameters
    const query = urlObj.search.substring(1); // remove the leading '?'
    
    // Split the query string by '|'
    const pairs = query.split('|');
    
    // Convert the pairs to an object
    const paramsObj = {};
    pairs.forEach(pair => {
      const [key, value] = pair.split(':');
      if (key && value) {
        paramsObj[key] = value;
      }
    });
    
    return paramsObj;
  }

  function getCustomFilterData(url) {
    // Create a URL object
    const urlObj = new URL(url);
    
    // Get the query string parameters
    const query = urlObj.search.substring(1); // remove the leading '?'
    const _query = query.split('=');
    // Split the query string by '|'
    const pairs = _query[1].split('|');
    
    // Convert the pairs to an object
    const paramsObj = {};
    pairs.forEach(pair => {
      const [key, value] = pair.split(':');
      if (key && value) {
        paramsObj[key] = value;
      }
    });
    
    return paramsObj;
  }

const compareDecending = ( a, b ) => {
if ( a.year > b.year ){
    return -1;
}
if ( a.year < b.year ){
    return 1;
}
return 0;
}
  
function returnCollectionURL(type, urlData){
    if(type == 'air_filter'){
        return pageURL = `/collections/air-filter?${urlData}`;
    }
    else if(type == 'oil_filter'){
        return pageURL = `/collections/oil-filter?${urlData}`;
    }
    else if(type == 'cabin_air_filter'){
        return pageURL = `/collections/cabin-air-filter?${urlData}`;
    }
    else if(type == 'fuel_filter'){
        return pageURL = `/collections/fuel-filter?${urlData}`;
    }
    else if(type == 'transmission_filter'){
        return pageURL = `/collections/transmission-filter?${urlData}`;
    }
}